import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareCustomHeaders } from "../utils/baseQueryHeaders";

type CreateChatRequest = {
  messages?: any[] | null;
  model_name?: string | null;
  config_overwrite?: Record<string, any> | null;
  use_web_search?: boolean;
};

type CreateChatResponse = {
  id: number;
  model_name: string;
  messages: any[];
};

type DeleteChatRequest = {
  chat_id: number;
};

type DeleteChatResponse = {
  chat_id: number;
};

type CreateMessageRequest = {
  chat_id: number;
  text: string;
  model_name: string | null;
  image_url?: string | null;
  overwrite_config?: Record<string, any> | null;
};

type CreateMessageResponse = {
  created_message: any;
  chat_id: string;
  value_error: string | null;
  error: string | null;
};

export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/_internal/gpt/chat",
    prepareHeaders: prepareCustomHeaders,
  }),
  tagTypes: ["Chat"],
  endpoints: (build) => ({
    createChat: build.mutation<CreateChatResponse, CreateChatRequest>({
      query: (body) => ({
        url: "/create",
        method: "POST",
        body,
      }),
    }),
    deleteChat: build.mutation<DeleteChatResponse, DeleteChatRequest>({
      query: (body) => ({
        url: `/delete/${body.chat_id}`,
        method: "DELETE",
      }),
    }),
    createMessage: build.mutation<CreateMessageResponse, CreateMessageRequest>({
      query: (body) => ({
        url: "/message",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateChatMutation,
  useDeleteChatMutation,
  useCreateMessageMutation,
} = chatApi;
